import * as React from 'react';
import { SVGProps } from 'react';
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M20.182 10.182C20.182 16.546 12 22 12 22s-8.182-5.454-8.182-11.818a8.182 8.182 0 0 1 16.364 0Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 12.91a2.727 2.727 0 1 0 0-5.455 2.727 2.727 0 0 0 0 5.454Z"
    />
  </svg>
);
export { SvgComponent as Marker };
